<template>
  <UppyFileUploader
    title="Upload Your Images"
    :url="url"
    :file-types="options.acceptedFiles"
    :meta="meta"
    :headers="headers"
    @uploaded="setOrderImage"
    @removed="removeFile"
    @upload="$emit('processing', true)"
    @complete="$emit('complete', true)"
    dashboard-height="350px !important"
    bg-color="#F5F7FE"
  >
    <template #label>
      <div
        class="d-flex align-items-center justify-content-center"
        style="height:310px"
      >
        <div class="pr-3 text-info" style="font-size:5rem">
          <i class="text-dark-50 flaticon-upload-1"></i>
        </div>
        <div>
          <p class="h4 text-info font-weight-light font-italic">
            <span class="h1">Drop Files</span> or
            <span class="underline">browse files</span>
          </p>
          <p>
            We support all major image format and there is no file size limit.
          </p>
        </div>
      </div>
    </template>
  </UppyFileUploader>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UppyFileUploader from "./UppyFileUploader.vue";

export default {
  components: {
    UppyFileUploader,
  },
  computed: {
    ...mapGetters({
      options: "upload/options",
      images: "order/images",
      orderUuid: "order/uuid",
    }),
    url() {
      return process.env.VUE_APP_API_URL + "/images";
    },
    meta() {
      return {
        token: this.orderUuid,
      };
    },
    headers() {
      return {
        Authorization: this.options.headers.Authorization,
      };
    },
  },

  methods: {
    ...mapActions({
      setImage: "order/setImage",
      deleteImage: "order/deleteImage",
    }),

    setOrderImage(data, response) {
      this.setImage({
        image: { uppy_id: data.id, ...response.body },
      });
    },

    removeFile(file) {
      let image = this.images.find((img) => {
        return img.uppy_id === file.id;
      });

      if (image) {
        this.deleteImage(image);
      }
    },
  },
};
</script>

<style lang="css">
.underline {
  text-decoration: underline;
}
</style>
